export { default } from "./split-timestamp";
